const mEditionMapEnrollmentsInvitationsModalCreate = {
  mEditionMapEnrollmentsInvitationsModalCreate: {
    alerts: {
      createInscripcion: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'La inscripción fue procesada exitosamente. El alumno recibirá un email de notificación para hacerle saber que su inscripción ha sido dada de alta.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'ENVIAR',

    inputs: {
      email: {
        label: 'Emails de Nuevos Alumnos',
        placeholder: 'Escribe aquí un email y presiona enter',
        tooltip: 'Si el o los alumnos ya pertenecen a la academia serán inscriptos en el mapa, caso contrario sus inscripciones serán habilitadas una vez que confirmen las invitaciones.'
      }
    },

    title: 'Enviar Invitación',

    validation: {
      email: {
        email: 'El email ingresado no es una cuenta válida.',
        required: 'Email de nuevo alumno es requerido.',
        invalid: 'Las siguientes casillas de correo no son válidas:',
        others: 'Y otras',
        more: 'casillas...'
      }
    }
  }
}

export default mEditionMapEnrollmentsInvitationsModalCreate
